<div class="sh-notification--update" *ngIf="showNotification$ | async">
    <div class="sh-notification__content" *ngIf="notificationContent$ | async as notificationContent">
        <h4 *ngIf="notificationContent.title" class="sh-notification__title">
            <sh-html-parser [message]="notificationContent.title"></sh-html-parser>
        </h4>
        <div class="sh-notification__msg">
            <p *ngFor="let paragraph of notificationContent.paragraphs">
                <sh-html-parser [message]="paragraph"></sh-html-parser>
            </p>
        </div>
    </div>
    <button type="button" class="sh-pure-icon-button sh-notification__close-button" aria-label="close" (click)="onClose()">
        <svg sh-icon class="sh-icon-button__icon" [name]="'close'"></svg>
    </button>
</div>
